<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Package Group Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="title" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit test package group'">
      <template #gated-content>
        <test-package-group-form
          :test_package_group="test_package_group"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestPackageGroupForm from "@/components/lab/testpackagegroup/form/TestPackageGroupForm";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testPackageGroupNotifications } from "@/shared/notifications";

Vue.use(VueNotifications, notificationOptions);

const TestPackageGroupRepository = LabRepositoryFactory.get("testPackageGroup");

export default {
  name: "TestPackageGroupEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestPackageGroupForm,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/testpackagegroups",
            title: "To the Test package groups page",
            variant: "primary",
          },
          {
            icon: "fa-eye",
            linkto: `/testpackagegroups/${this.test_package_group_id}`,
            title: "To the Test package groups page",
            variant: "info",
          },
        ],
      };
    },
    title() {
      return `Update ${this.test_package_group.name} Test Package Group`;
    },
  },
  data() {
    return {
      loading: true,
      test_package_group_id: this.$route.params.test_package_group_id || null,
      test_package_group: null,
    };
  },
  methods: {
    async submit(form_data) {
      try {
        await TestPackageGroupRepository.update(
          this.test_package_group_id,
          form_data
        );

        this.editSuccess();
        this.$router.push(`/testpackagegroups/${this.test_package_group_id}`);
      } catch ({ response }) {
        this.editFail();
      }
    },
  },
  async created() {
    this.loading = true;

    this.test_package_group = await getModel({
      model_type: "test_package_group",
      id: this.test_package_group_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: testPackageGroupNotifications,
};
</script>
